import React from 'react';
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {Card} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import moment from "moment";

class DialogDetallePanelGeneral extends React.Component{
    constructor(props) {
        super(props);
        var tiempo_general = 0
        var tiempo_altillo = 0
        var tiempo_sala = 0
        var tiempo_visual = 0
        var tiempo_trastienda = 0
        var tiempo_bodega = 0

        if (this.props.rowData.inicio_general !== 'SIN CONTEO' && this.props.rowData.termino_general !== 'SIN CONTEO'){
            var inicio_general = moment(this.props.rowData.inicio_general, "YYYY/MM/DD HH:mm:ss");
            var termino_general = moment(this.props.rowData.termino_general, "YYYY/MM/DD HH:mm:ss");
            tiempo_general = termino_general.diff(inicio_general, "hours", true);
        }

        if (this.props.rowData.inicio_altillo !== 'SIN CONTEO' && this.props.rowData.termino_altillo !== 'SIN CONTEO'){
            var inicio_altillo = moment(this.props.rowData.inicio_altillo, "YYYY/MM/DD HH:mm:ss");
            var termino_altillo = moment(this.props.rowData.termino_altillo, "YYYY/MM/DD HH:mm:ss");
            tiempo_altillo = termino_altillo.diff(inicio_altillo, "hours",true);
        }

        if (this.props.rowData.inicio_bodega !== 'SIN CONTEO' && this.props.rowData.termino_bodega !== 'SIN CONTEO'){
            var inicio_bodega = moment(this.props.rowData.inicio_bodega, "YYYY/MM/DD HH:mm:ss");
            var termino_bodega = moment(this.props.rowData.termino_bodega, "YYYY/MM/DD HH:mm:ss");
            tiempo_bodega = termino_bodega.diff(inicio_bodega, "hours",true);
        }

        if (this.props.rowData.inicio_sala !== 'SIN CONTEO' && this.props.rowData.termino_sala !== 'SIN CONTEO'){
            var inicio_sala = moment(this.props.rowData.inicio_sala, "YYYY/MM/DD HH:mm:ss");
            var termino_sala = moment(this.props.rowData.termino_sala, "YYYY/MM/DD HH:mm:ss");
            tiempo_sala =  termino_sala.diff(inicio_sala, "hours",true);
        }

        if (this.props.rowData.inicio_trastienda !== 'SIN CONTEO' && this.props.rowData.termino_trastienda !== 'SIN CONTEO'){
            var inicio_trastienda = moment(this.props.rowData.inicio_trastienda, "YYYY/MM/DD HH:mm:ss");
            var termino_trastienda = moment(this.props.rowData.termino_trastienda, "YYYY/MM/DD HH:mm:ss");
            tiempo_trastienda =termino_trastienda.diff(inicio_trastienda, "hours",true)
        }

        if (this.props.rowData.inicio_visual !== 'SIN CONTEO' && this.props.rowData.termino_visual !== 'SIN CONTEO'){
            var inicio_visual = moment(this.props.rowData.inicio_visual, "YYYY/MM/DD HH:mm:ss");
            var termino_visual = moment(this.props.rowData.termino_visual, "YYYY/MM/DD HH:mm:ss");
            tiempo_visual = termino_visual.diff(inicio_visual, "hours",true);
        }

        this.state = {
            rowData: this.props.rowData,
            tiempo_general: tiempo_general,
            tiempo_altillo: tiempo_altillo,
            tiempo_bodega: tiempo_bodega,
            tiempo_sala: tiempo_sala,
            tiempo_visual: tiempo_visual,
            tiempo_trastienda: tiempo_trastienda,
        }

    }

    render() {
        return(
            <Dialog
                open={true}
                fullWidth
                maxWidth="md"
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">Datos adicionales</DialogTitle>
                <DialogContent>
                    <Grid container spacing={1} style={{ padding:5}}>
                        <Grid item xs={12}>
                            <Card>
                                <CardContent>
                                    <Typography sx={{fontSize: 14}} >
                                        Analista/Auditor Responsable: {this.state.rowData.analista_responsable}
                                    </Typography>
                                    <Typography  sx={{fontSize: 14}} >
                                        Supervisor SCA: {this.state.rowData.coordinador}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12}>
                            <Card>
                                <CardContent>
                                    <Typography sx={{fontSize: 14}} >
                                        Hora Variance: {this.state.rowData.hora_variance}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={6}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h6" component="div">
                                        General
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Inicio: {this.state.rowData.inicio_general}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}} gutterBottom>
                                        Termino: {this.state.rowData.termino_general}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Hrs: {this.state.tiempo_general}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        % Validación: {(this.state.rowData.validacion_general * 100).toFixed(2)}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={6}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h6" component="div">
                                        Altillo
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Inicio: {this.state.rowData.inicio_altillo}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}} gutterBottom>
                                        Termino: {this.state.rowData.termino_altillo}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Hrs: {this.state.tiempo_altillo}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        % Validación: {(this.state.rowData.validacion_altillo * 100).toFixed(2)}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={6}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h6" component="div">
                                       Sala
                                    </Typography>
                                    <Typography sx={{fontSize: 14}} gutterBottom>
                                        Inicio: {this.state.rowData.inicio_sala}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}} gutterBottom>
                                        Termino: {this.state.rowData.termino_sala}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Hrs: {this.state.tiempo_sala}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        % Validación: {(this.state.rowData.validacion_sala * 100).toFixed(2)}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={6}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h6" component="div">
                                        Bodega
                                    </Typography>
                                    <Typography sx={{fontSize: 14}} gutterBottom>
                                        Inicio: {this.state.rowData.inicio_bodega}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Termino: {this.state.rowData.termino_bodega}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Hrs: {this.state.tiempo_bodega}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        % Validación: {(this.state.rowData.validacion_bodega*100).toFixed(2)}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={6}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h6" component="div">
                                        Trastienda
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Inicio: {this.state.rowData.inicio_trastienda}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Termino: {this.state.rowData.termino_trastienda}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Hrs: {this.state.tiempo_trastienda}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        % Validación: {(this.state.rowData.validacion_trastienda *100).toFixed(2)}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={6}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h6" component="div">
                                        Visual
                                    </Typography>
                                    <Typography sx={{fontSize: 14}} gutterBottom>
                                        Inicio: {this.state.rowData.inicio_visual}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}} gutterBottom>
                                        Termino: {this.state.rowData.termino_visual}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        Hrs: {this.state.tiempo_visual}
                                    </Typography>
                                    <Typography sx={{fontSize: 14}}  gutterBottom>
                                        % Validación: {(this.state.rowData.validacion_visual*100).toFixed(2)}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

}

export default DialogDetallePanelGeneral;